import React from 'react';
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_ACCESS_MAP_DIRECT, ROUTE_CONFIG } from '../libs/routeList';


// const ProtectedRoute = ({ children }) => {
//     const { isAuthenticated, auth_info } = useSelector((state) => state.auth);
//     const location = useLocation();

//     console.log(auth_info, "auth_info12321");

//     if (!isAuthenticated) {
//         return <Navigate to="/login" replace />;
//     }

//     let accessKey = location.pathname
//         .replace(/^\//, "")
//         .replace(/\//g, "_")
//         .replace(/-/g, "_")
//         .toLowerCase();


//     const userAccessList = auth_info?.company_user_access || [];
//     const hasPermission = userAccessList.includes(accessKey);

//     if (!hasPermission) {
//         return <Navigate to="/no-access" replace />;
//     }

//     return children;
// };

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, auth_info } = useSelector((state) => state.auth);
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (location.pathname === "/" || location.pathname === "/login") {
        return <Navigate to={auth_info?.route_path} replace />;
    }

    let accessKey = ROUTE_ACCESS_MAP_DIRECT[location.pathname];
    if (!accessKey) {
        let patterns = Object.keys(ROUTE_ACCESS_MAP_DIRECT || {});
        let matchedPattern = patterns.find((routePattern) => {
            if (!routePattern || typeof routePattern !== "string") {
                console.warn("Invalid routePattern:", routePattern);
                return false;
            }
            let regexPattern;
            try {
                regexPattern = new RegExp(
                    "^" + routePattern.replace(/:[^\s/]+/g, "[^/]+") + "$"
                );
            } catch (err) {
                console.error("Regex creation failed for:", routePattern, err);
                return false;
            }
            return regexPattern.test(location.pathname);
        });
        console.log(matchedPattern, "matchedPattern");

        if (matchedPattern) {
            accessKey = ROUTE_ACCESS_MAP_DIRECT[matchedPattern];
        }
    }

    if (!accessKey) {
        return children;
    }

    const routeConfig = ROUTE_CONFIG[location.pathname];

    const isIndia = auth_info?.country?.toLowerCase() === "india";
    const isGstEnabled = String(auth_info?.gst_enabled).toLowerCase() === "yes";

    if (routeConfig?.feature === "GST" && !(isIndia && isGstEnabled)) {
        return <Navigate to="/no-access" replace />;
    }

    if (routeConfig?.feature === "TATMEEN_CUSTOM" && auth_info?.is_tatmeen_enabled !== "custom") {
        return <Navigate to="/no-access" replace />;
    }

    const userAccessList = auth_info?.company_user_access || [];
    const hasPermission = userAccessList.some(
        (item) => item.access === accessKey
    );

    const isModuleDisabled = (auth_info?.disabled_modules || []).includes(accessKey);

    if (!hasPermission || isModuleDisabled) {
        return <Navigate to="/no-access" replace />;
    }
    return children;
};


export default ProtectedRoute;